import { IBaseAction } from '@models/actions/IBaseAction';
import { getDocIdFromLinkedDocId } from '@utils/helpers';
import { DocumentActionsService } from '@services/actions/DocumentActionsService';
import { AccessibilityActionExecutor } from './AccessibilityActionExecutor';

/** Результат групповой проверки у документов: по группе на каждый набор ид */
type DocGroupResult = { isAccessibly: boolean; docIds: string[]; errors?: string[] }[];

export abstract class DocBaseActionExecutor extends AccessibilityActionExecutor<DocGroupResult> {
    protected _action?: IBaseAction;

    protected storeAction(_objId: string, action: IBaseAction) {
        this._action = action;
    }

    /** Если прилетает ИД линкованного документа вида [ИД родителя]/[ИД линкованного документа] */
    protected resolveObjId(objId: string): string {
        return objId
            .split(',')
            .map((id) => (id.split('/').length === 2 ? getDocIdFromLinkedDocId(id) : id))
            .join(',');
    }

    protected resolveAccessibilityId(objId: string): string {
        return this.resolveObjId(objId);
    }

    protected getService() {
        return new DocumentActionsService();
    }

    protected handleGroupAccessibility(
        data: DocGroupResult,
        run: (objId: string, action: IBaseAction) => void,
        fail: (errors?: string[]) => void,
        action: IBaseAction,
    ) {
        const runGroup = (response: DocGroupResult[number], actionLocal: IBaseAction) => {
            if (response.isAccessibly) {
                //успешная проверка групповой Accessibility
                run(response.docIds.join(','), actionLocal);
            } else {
                fail(response.errors);
            }
        };

        if (data.length == 1) {
            runGroup(data[0], action);
        } else {
            // Каждая группа открывается своей вкладкой, поэтому действию нужна копия с newTab
            const copyAction = JSON.parse(JSON.stringify(action));
            copyAction.options.newTab = true;
            data.forEach((dataGroup) => {
                runGroup(dataGroup, copyAction);
            });
        }
    }
}
